import chess from './chess.jpg';
import home_bg from './home-bg.png';
import profile from './profile.png';
import profile_personal_data from './profile-personal-data.svg';
import profile_notifications from './profile-notifications.png';
import profile_settings from './profile-settings.png';
import profile_bg from './profile-bg.png';
import settings_login from './settings-login.png';
import settings_logout from './settings-logout.png';
import settings_notifications from './settings-notifications.png';
import settings_contract from './settings-contract.png';
import messages_bg from './messages-bg.png';
import contact_bg from './contact-bg.png';
import contact from './contact.png';
import exchange_order_bg from './exchange-order-bg.png';
import orders_bg from './orders-bg.png';
import money_transfers_bg from './money-transfers-bg.png';
import settings_language from './earth.jpg';


export const images = {
  // backgrounds
  home_bg,
  profile_bg,
  contact_bg,
  messages_bg,
  exchange_order_bg,
  orders_bg,
  money_transfers_bg,

  // profile menu
  profile_personal_data,
  profile_notifications,
  profile_settings,

  // profile menu item
  profile,

  // settings menu
  settings_login,
  settings_logout,
  settings_notifications,
  settings_contract,
  settings_language,

  // login
  chess,

  // contact
  contact,
};
